const isBankWireOnly = product => {
  if (!product) return false
  return product.ask_for_price === 2
}

export default isBankWireOnly
